document.addEventListener("DOMContentLoaded", () => {
  const $featureBlocks = Array.from(
    document.querySelectorAll(".additional-features")
  )
  if ($featureBlocks.length) {
    for (const $featureBlock of $featureBlocks) {
      const blocks = $featureBlock.querySelector(".additional-features__blocks")

      // Close all other details when one is shown
      blocks.addEventListener("sl-show", (event) => {
        if (event.target.localName === "sl-details") {
          ;[...blocks.querySelectorAll("sl-details")].map(
            (details) => (details.open = event.target === details)
          )
        }
      })

      // Desktop
      const defaultImg = $featureBlock.querySelector(
        ".additional-features__image-default"
      )
      const allImgElem = $featureBlock.querySelectorAll(
        ".additional-features__image img"
      )
      const items = $featureBlock.querySelectorAll(".additional-features__item")
      items.forEach((item) => {
        item.addEventListener("mouseenter", (event) => {
          const imgElem = $featureBlock.querySelector(
            `.additional-features__image-${item.dataset.index}`
          )
          allImgElem.forEach((img) => img.classList.add("transparent"))
          imgElem.classList.remove("transparent")
        })
      })

      $featureBlock.addEventListener("mouseleave", (event) => {
        allImgElem.forEach(
          (img) => img !== defaultImg && img.classList.add("transparent")
        )
        defaultImg.classList.remove("transparent")
      })
    }
  }
})
